import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Transferencia de Confianza',
      text: 'La audiencia de Margarita es extremadamente fiel. Si Margarita usa Artesco para sus momentos más íntimos de fe, su audiencia también lo hará.',
    },
    {
      title: 'Contexto Premium',
      text: 'El TNO Media Lab garantiza que los colores y la textura de los productos Artesco se vean vibrantes y profesionales, elevando la percepción de calidad de la marca.',
    },
    {
      title: 'Conexión Emocional',
      text: 'Salimos de la competencia por precio y entramos en el terreno del valor sentimental. Artesco se convierte en el compañero de las oraciones de la familia venezolana.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Ventajas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Por qué Artesco + Margarita es la alianza perfecta
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
